/* RNR header search toggle. BAVS 2026-10.
   Small screens only; the CSS decides when the button is visible, this
   just flips the state and gets the cursor into the field. */
(function () {
  var inner = document.querySelector('.header--inner');
  var toggle = document.querySelector('.rnr-search-toggle');
  if (!inner || !toggle) return;

  var input = inner.querySelector('.searchform input[type="search"], .searchform input[name="q"]');

  function setOpen(open) {
    inner.classList.toggle('rnr-search-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && input) {
      // the field is display:none until the class lands, and focus is
      // refused while an element is still hidden, so let a tick pass
      setTimeout(function () {
        try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
      }, 60);
    }
  }

  toggle.addEventListener('click', function () {
    setOpen(!inner.classList.contains('rnr-search-open'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && inner.classList.contains('rnr-search-open')) {
      setOpen(false);
      toggle.focus();
    }
  });
})();
